import { ArrowRightIcon, BriefcaseIcon } from "@phosphor-icons/react";
import { Link } from "@tanstack/react-router";
import { motion } from "motion/react";

import { Spotlight } from "@/components/animation/spotlight";
import { Button } from "@/components/ui/button";

export function Hero() {
  return (
    <section
      id="hero"
      className="relative flex min-h-svh w-full flex-col items-center justify-center overflow-hidden border-b py-24"
    >
      <Spotlight />

      <div className="xs:px-0 relative z-10 flex max-w-2xl flex-col items-center gap-y-6 px-4 text-center">
        {/* Headline */}
        <motion.div
          className="will-change-[transform,opacity]"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.3 }}
        >
          <p className="font-medium tracking-tight text-muted-foreground md:text-lg">
            Build your professional CV in minutes
          </p>
          <h1 className="mt-1 text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl">
            Free Resume Builder for Workers
          </h1>
        </motion.div>

        {/* Description */}
        <motion.p
          className="max-w-xl text-base leading-relaxed text-muted-foreground will-change-[transform,opacity] md:text-lg"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.5 }}
        >
          Create a professional CV, download as PDF, and apply for jobs — completely free. Designed for blue-collar
          workers and professionals in the UAE and beyond.
        </motion.p>

        {/* CTA Buttons */}
        <motion.div
          className="flex flex-col items-center gap-3 will-change-[transform,opacity] sm:flex-row sm:gap-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, delay: 0.7 }}
        >
          <Button
            size="lg"
            nativeButton={false}
            className="group relative overflow-hidden px-4"
            render={
              <Link to="/dashboard">
                <span className="relative z-10 flex items-center gap-2">
                  Build My CV
                  <ArrowRightIcon
                    aria-hidden="true"
                    className="size-4 transition-transform group-hover:translate-x-0.5"
                  />
                </span>
              </Link>
            }
          />

          <Button
            size="lg"
            variant="ghost"
            className="gap-2 px-4"
            nativeButton={false}
            render={
              <a href="https://workforce.huntr.app/candidate/login" target="_blank" rel="noopener noreferrer">
                <BriefcaseIcon aria-hidden="true" className="size-4" />
                Apply for Jobs
                <span className="sr-only">(opens in new tab)</span>
              </a>
            }
          />
        </motion.div>
      </div>
    </section>
  );
}
